/* src/app/features/contratacao/consulta-cadin/consulta-cadin-listar.component.scss */
.cadin-bolinha {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.cadin-verde {
  background-color: #8bc34a;
}
.cadin-amarelo {
  background-color: #f0ad4e;
}
.cadin-vermelho {
  background-color: #e53935;
}
.cadin-cinza {
  background-color: #adb5bd;
}
.cadin-legenda {
  display: flex;
  gap: 20px;
  margin: 8px 0 16px;
  font-size: 13px;
  color: #6c757d;
  flex-wrap: wrap;
}
.cadin-legenda-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
/*# sourceMappingURL=consulta-cadin-listar.component.css.map */
